import { App } from "vue-demi";
import { i18n } from "@/i18n";

export const setPlugins = (app: App<Element>) => {
  app.use(i18n);

  return {
    i18n,
  };
};
